import axios from "axios";
import platform from "platform";

import { IpInfoResponse, Subscription } from "models/User";

import { getAPIService, postAPIService } from "./BaseServce";

export const generateAPIKey = async () => {
  const res = await postAPIService("/api-keys");
  return res.data;
};

export const changePassword = async (password: string, newPassword: string) => {
  const res = await postAPIService("/auth/change-password", {
    password,
    new_password: newPassword,
  });
  return res.data;
};

export const getUserInfo = async () => {
  const res = await getAPIService("/user-info");
  return res.data;
};

export const getUserPreferences = async () => {
  const res = await getAPIService("/user-preferences");
  return res.data;
};

export const updateUserPreferences = async (key, value, append) => {
  const res = await postAPIService("/user-preferences", { key, value, append });
  return res.data;
};

export const updateUserInfo = async (values) => {
  const res = await postAPIService("/user-info", {
    name: values.name,
    last_name: values.lastName,
    email: values.emailId,
    timezone: values.timezone,
  });
  return res.data;
};

export const getUserProfilePicture = async () => {
  const res = await getAPIService("/profile-picture");
  return res.data;
};
export const refreshUser = async () => {
  const res = await getAPIService("/user/refresh");
  return res.data;
};

export const getIpInfo = async (): Promise<IpInfoResponse | null> => {
  try {
    const res = await axios.get("https://ipinfo.io");
    return res.data;
  } catch (e) {
    console.error("ipinfo lookup failed:", e);
    return null;
  }
};

// Always sends the ipinfo details, plus `event_id` when the Fingerprint agent
// loaded. The backend prefers Fingerprint and uses ipinfo only as a fallback,
// so one request covers both cases with no retry.
export const updateUserAccessInfo = async (eventId?: string | null) => {
  const ipInfo = await getIpInfo();
  if (!ipInfo && !eventId) return null;

  const res = await postAPIService("/user/refresh", {
    event_id: eventId ?? undefined,
    ip: ipInfo?.ip,
    geo_data: ipInfo ?? undefined,
    platform_data: platform,
  });
  return res.data;
};

export const exitImpersonation = async () => {
  const res = await getAPIService("/user/exit-impersonation");
  return res.data;
};

export const updateProfilePicture = async (formData) => {
  const res = await postAPIService("/profile-picture", formData);
  return res.data;
};

export const updateUserNotificationCategories = async (
  categories: string[],
) => {
  const res = await postAPIService("/user/notification-categories", {
    categories,
  });
  return res.data;
};

export const getSubscription = async (companyId?: number) => {
  const res = await getAPIService("/subscription", { company_id: companyId });
  return res.data as Subscription;
};
